// extracted by mini-css-extract-plugin
module.exports = {"messageForm":"MessageForm_messageForm__CXUkq","messageFormEditor":"MessageForm_messageFormEditor__2cQ8J"};